<template>
    <div class="text-grey-9 row shadow-up-2 bg-grey-11" >
        <div class="col-md-10 offset-md-1 col-xs-12 offset-xs-0">
            <q-toolbar >

                <q-toolbar-title>
                    <a href="/">
                        <img src="/img/pmmc.png" width="200" class="q-pt-sm mobilehide">
                        <img src="/img/brasao.png" width="50" class="q-pt-sm mobileshow">
                    </a>
                </q-toolbar-title>

                <div class="text-center mobilehide">
                    <b>Secretaria Assistência Social</b> - Vigilância Socioassistencial<br>
                    <b>Visor de Informações para o Sistema Único de Assistência Social - VISUAS</b>
                </div>
                <div class="text-center mobileshow">
                    Secretaria de Assistência Social<br>
                    <b>VISUAS</b>
                </div>
                <q-space />

                <!-- <q-btn size="sm" flat icon="https" to="/admin" class="text-grey-5 mobilehide" label="Acesso restrito" />                   -->
                <q-btn size="sm" flat icon="https" to="/admin" class="text-grey-5">
                    <q-tooltip>Acesso restrito</q-tooltip>
                </q-btn>

            </q-toolbar>


        </div>
        <q-toolbar inset class="bg-blue-grey-8">
            <q-space />
            <q-tabs v-model="tab" shrink class="text-blue-grey-2">
                <q-route-tab name="tab1" label="Apresentação" to="/" />
                <q-route-tab name="tab2" label="Assistência Social" to="/assistencia" />
                <q-route-tab name="tab3" label="Créditos" to="/creditos" />
                <q-route-tab name="tab4" label="Atualizações" to="/atualizacoes" />
                <q-route-tab name="tab5" label="Mapa" to="/mapa" />
                <q-route-tab name="tab6" label="Painel" to="/painel" />
           
            </q-tabs>
            
            <q-space />
            <!-- <q-btn class="text-blue-grey-2" flat @click="drawerRight = !drawerRight" round dense icon="menu" v-if="tab=='tab5'" /> -->
        </q-toolbar>
    </div>
</template>

<script>

    export default {
        data: () => ({
            appName: window.config.appName,
            tab: 'tab1',
          // btnToggle: 'um'
        }),
    }
</script>

<style>
    @media (max-width: 1023px) {
        .mobilehide {
            display: none;
        }

        .mobileshow {
            display: block;
        }
    }

    @media (min-width: 1024px) {
        .mobilehide {
            display: block;
        }

        .mobileshow {
            display: none;
        }
    }

    .toolbar {
         /* background-image: url("/img/fundo5.jpg");  */

        /* The image used */
         background-color: #cccccc;
         /* background-color:rgb(255, 255, 255);  */
        /* Used if the image is unavailable */
        /* height: 500px; */
        /* You must set a specified height */
        background-position: center;
        /* Center the image */
        background-repeat: no-repeat;
        /* Do not repeat the image */
        background-size: cover;
        /* Resize the background image to cover the entire container */
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/GuestToolbar.vue